import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Descriptions, Input, Row, Table } from 'antd';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IPermission, crud } from '../../../../common/types/commonTypes';
import { removeSpaceBeforeWord } from '../../../../components/common/Invoice/InvoiceListHeader';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import { useGetAllTourRefundsQuery } from '../../Api/Endpoints/TourPackageRefundEndpoints';
import { TourRefundClientViewUtils } from '../../Utils/TourPackageUtils/TourRefundClientViewUtils';
import { rangePresets } from '../../../../common/utils/common.utils';

type Props = { permission?: IPermission };

const TourRefundHistory = ({ permission }: Props) => {
  const [date, setDate] = useState([]);
  const [search, setSearch] = useState('');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
  });

  const { data, isLoading, isFetching, refetch } = useGetAllTourRefundsQuery({
    ...pagination,
    from: date[0] || '',
    to: date[1] || '',
    search: search,
  });

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      current: 1,
      pageSize: 20,
    }));
  }, [search, date]);

  const handlePaginationChange = (current: number, pageSize: number) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current,
      pageSize,
    }));
  };

  // Handle Search Operation

  const handleDateRangeChange = (date: any, dateString: any) => {
    setDate(dateString);
  };

  const handleSearch = (e: any) => {
    setSearch(removeSpaceBeforeWord(e.target.value));
  };
  return (
    <>
      <BreadCrumb
        arrOfOption={['Refund', 'Others Refund']}
        refetch={() => refetch()}
        reloaderSize='small'
      />
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 10 }}
        style={{ marginBottom: '25px' }}
        justify={'space-between'}
      >
        {permission?.[crud.create] && (
          <Link to='/refund/tour-package'>
            <Button type='primary'>
              <PlusOutlined />
              Add Tour Refund
            </Button>
          </Link>
        )}

        <Col span={12}>
          <Row justify={'end'} gutter={10}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <DatePicker.RangePicker
                presets={rangePresets}
                format={'YYYY-MM-DD'}
                onChange={handleDateRangeChange}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Input
                placeholder='Search Invoices...'
                onBlur={handleSearch}
                onPressEnter={handleSearch}
                allowClear
              ></Input>
            </Col>
          </Row>
        </Col>
      </Row>

      <Table
        size='small'
        bordered
        columns={TourRefundClientViewUtils({ permission, pagination })}
        dataSource={data?.data}
        pagination={
          data?.count !== undefined && data?.count < 20
            ? false
            : {
                ...pagination,
                total: data?.count,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '200', '500'],
                onChange: handlePaginationChange,
              }
        }
        scroll={{ x: true }}
        loading={{
          spinning: isLoading || isFetching,
          indicator: loadingIndicator,
        }}
        expandable={{
          expandedRowRender: (record, index) => {
            return (
              <Descriptions bordered column={3}>
                <Descriptions.Item label='Client Name'>
                  {record.client_name}
                </Descriptions.Item>
                <Descriptions.Item label='Refund Charge'>
                  {Number(record.refund_charge)}
                </Descriptions.Item>
                <Descriptions.Item label='Type'>
                  {record.payment_type}
                </Descriptions.Item>
              </Descriptions>
            );
          },
        }}
        rowKey={(_, index) => index || 0}
      />
    </>
  );
};

export default TourRefundHistory;
